import { useEffect } from 'react';

import { ChakraBox, ChakraFlex, MaudSectionHeader } from '@equip.health/ui';
import { useHistory, useLocation } from 'react-router-dom';

import { useGlobalContext } from '~/lib/contexts/GlobalContext';
import { isAuthorizedRoute } from '~/lib/util/routes.util';
import { Path } from '~/routes/constants';

import CalendarTabs from './CalendarTabs';
const Calendar = () => {
  const { permissions, setIsOnCalendar } = useGlobalContext();

  const history = useHistory();
  const location = useLocation();

  const isAuthorized = isAuthorizedRoute(location.pathname, permissions);

  useEffect(() => {
    if (isAuthorized) {
      setIsOnCalendar(true);
    } else {
      history.push(Path.HOME);
    }

    return () => {
      if (isAuthorized) setIsOnCalendar(false);
    };
  }, [isAuthorized]);
  return (
    <ChakraFlex direction="column" height="100%" paddingTop="24px">
      <ChakraBox paddingBottom="10px" paddingRight="24px">
        <MaudSectionHeader
          id="TODO ADD PROPER ID ANYONE DEVELOPING THIS FEATURE PLEASE CHANGE"
          // onAdd={() => alert('under Development')}
          // onAddTitle="Action"
          title="Calendar"
        />
      </ChakraBox>
      <CalendarTabs />
    </ChakraFlex>
  );
};

export default Calendar;
